// src/pages/cuentas-bancarias/EliminarCuenta.js
import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'

function EliminarCuenta(props) {
	const { cuenta, mostrar, cancelar, eliminar } = props

	const handleClose = () => {
		cancelar()
	}

	const handleEliminar = () => {
		if (cuenta?.id) {
			eliminar(cuenta.id)
		}
	}

	if (!cuenta) {
		return null
	}

	// render
	return (
		<Modal show={mostrar} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Eliminar Cuenta Bancaria</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					<i className="fa fa-exclamation-triangle me-2"></i>
					Esta a punto de eliminar la siguiente cuenta bancaria. Esta accion no se puede deshacer.
				</Alert>

				<div className="p-3 bg-light rounded mb-3">
					<h6 className="text-muted mb-2">Datos de la cuenta:</h6>
					<table className="table table-sm table-borderless mb-0">
						<tbody>
							<tr>
								<td className="text-muted" style={{ width: '120px' }}>Banco:</td>
								<td><strong>{cuenta.banco}</strong></td>
							</tr>
							<tr>
								<td className="text-muted">Numero:</td>
								<td>{cuenta.numero_cuenta}</td>
							</tr>
							<tr>
								<td className="text-muted">Titular:</td>
								<td>{cuenta.titular}</td>
							</tr>
						</tbody>
					</table>
				</div>

				<p className="mb-0">Esta seguro que desea continuar?</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-secondary" onClick={handleClose}>
					<i className="fa fa-times me-2"></i>
					Cancelar
				</Button>
				<Button variant="danger" onClick={handleEliminar}>
					<i className="fa fa-trash me-2"></i>
					Eliminar
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default EliminarCuenta
